import { useMutation, UseMutationResult } from "react-query";
import { fileApi } from "../api/fileApi";

const useUploadFile = (defaultPath?: string): UseMutationResult<string, unknown, File, unknown> => {
    return useMutation((file: File, path?: string) => {
        return fileApi.uploadFile(file, path || defaultPath || "").then((res) => res.data);
    });
};

export default useUploadFile;
